import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import { Redirect } from 'react-router-dom';
import SidebarAdmin from '../layout/SidebarAdmin';
import EventoElement from '../eventi/EventoElement';
import { getEventiAgendaAdmin } from '../../actions/agenda';
import { extractRoomKey } from '../../utils/utilityfunction';



const ArchivioEventi = ({ auth: { user, loading }, alert, getEventiAgendaAdmin, agenda: { eventi }  }) => {

  const [eventiData, setEventiData] = useState([]);
  const [dataInizio, setDataInizio] = useState();
  const [dataFine, setDataFine] = useState();

  const formatDate = (date) => {
    const offset = date.getTimezoneOffset(); // Ottiene l'offset in minuti
    const adjustedDate = new Date(date.getTime() - (offset * 60 * 1000)); // Regola l'ora per considerare l'offset
    return adjustedDate.toISOString().split('T')[0]; // Ritorna la data in formato yyyy-mm-dd
  };

  useEffect(() => {
		setEventiData(eventi)
	}, [eventi]);

  useEffect(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), 0, 1); 
    const lastDay = new Date(); 
    setDataInizio(formatDate(firstDay));
    setDataFine(formatDate(lastDay));
    getEventiAgendaAdmin({ dataInizio: firstDay, dataFine: lastDay });
  }, []);

  const onChangeDataInizio = (e) => {
    setDataInizio(e.target.value);
    getEventiAgendaAdmin({ dataInizio: e.target.value, dataFine: dataFine });
  }

  const onChangeDataFine = (e) => {
    setDataFine(e.target.value);
    getEventiAgendaAdmin({ dataInizio: dataInizio, dataFine: e.target.value });
  }

  if (user && user.ruolo !== 'admin') {
    return <Redirect to="/login" />;
  }

  return (loading ? <Spinner /> :
    <section className="fd-section wide">
      <div className="w-layout-blockcontainer fd-container null w-container">
        <div className="fd-wrap backend">
          <SidebarAdmin />
          <div>
            <div>
              <div className="w-layout-blockcontainer fd-container backend w-container">
                <div className="fd-wrap">
                  <div className="w100">
                    <div>
                      <h1 className="heading-3">Archivio eventi</h1>
                    </div>
                    <div className="data_above">
                    <input type="date" className="input-field w-input" name="dataInizio" data-name="dataInizio" id="dataInizio" value={dataInizio} onChange={e => onChangeDataInizio(e)} />
                    <input type="date" className="input-field w-input" name="dataFine" data-name="dataFine" id="dataFine" value={dataFine} onChange={e => onChangeDataFine(e)} />
                    </div>
                    <div className="call-elenco">
                      {eventiData.map((el) => (
                        <EventoElement
                          titoloEvento={el.titolo}
                          descrizioneEvento={el.descrizione}
                          dataEvento={el.data}
                          orarioEvento={el.orario}
                          linkEvento={el.link}
                          roomName={el.roomName}
                          roomKey={extractRoomKey(el.hostRoomUrl)}
                          idEvento= {el._id}
                          archivio={true}
                          isActive={false}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
};

ArchivioEventi.propTypes = {
  auth: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  agenda: PropTypes.func.isRequired,
  getEventiAgendaAdmin: PropTypes.func.isRequired

}

const mapStateToProps = state => ({
  auth: state.auth,
  alert: state.alert,
  agenda: state.agenda
});

export default connect(mapStateToProps, { getEventiAgendaAdmin })(ArchivioEventi);